import PropTypes from 'prop-types';

const menuItemShape = PropTypes.shape({
  label: PropTypes.string.isRequired,
  href: PropTypes.string.isRequired,
  isMobileOnly: PropTypes.bool,
  onClick: PropTypes.func,
});

export default menuItemShape;
